var map = {
	"./icon-doc.png": 512,
	"./icon-docx.png": 513,
	"./icon-pdf.png": 518,
	"./icon-ppt.png": 516,
	"./icon-pptx.png": 517,
	"./icon-txt.png": 519,
	"./icon-xls.png": 514,
	"./icon-xlsx.png": 515
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3553;